import { useIonViewWillEnter } from "@ionic/react";
import { IDeck } from "@models/deck";
import { isDeckFSRS } from "@models/deckSettings";
import { decksGradePercent } from "@models/folder";
import { useEffect, useState } from "react";

// useGradePercent will return NaN when a deck is NEW, and undefined when loading.
export function useGradePercent(
  decks: IDeck[] | undefined,
  hideGrade: boolean,
): number | undefined {
  const [renderCounter, setRenderCounter] = useState(0);
  useIonViewWillEnter(() => {
    setRenderCounter((prev) => prev + 1);
  });

  const [gradePercent, setGradePercent] = useState<number>();
  // biome-ignore lint/correctness/useExhaustiveDependencies: renderCounter is intentionally used to trigger re-runs when view enters
  useEffect(() => {
    if (hideGrade || !decks) {
      return;
    }

    function updateGradePercent() {
      if (hideGrade || !decks) {
        return;
      }

      // Check if any deck is in FSRS mode - skip grade calculation for FSRS decks
      const hasAnyFSRSDecks = decks.some((deck) => isDeckFSRS(deck));

      if (hasAnyFSRSDecks) {
        // For FSRS decks, don't show traditional grades
        setGradePercent(undefined);
        return;
      }

      decksGradePercent(decks)
        .then((gradePct) => {
          setGradePercent(gradePct);
        })
        .catch((error) => {
          // Handle errors gracefully, especially for mixed mode scenarios
          console.warn("Grade calculation failed:", error);
          setGradePercent(undefined);
        });
    }

    updateGradePercent();
  }, [hideGrade, decks, renderCounter]);

  return gradePercent;
}
